import React from "react"

import Chip, { ChipColorType } from "@components/ui/Chip/Chip"
import Icon from "@components/ui/Icon/Icon"
import { IconName } from "@components/ui/Icon/IconName"
import { ExpertQuestion } from "@framework/types/question"
import { SearchCitationData } from "@store/search/search-citations.store"

import {
  ChatAnswerSourceKind,
  getChatAnswerSourceKind,
} from "./utils/answerSource"

import styles from "./AnswerSummary.module.sass"

const BADGE_CONFIG: Record<
  ChatAnswerSourceKind,
  { label: string; color: ChipColorType; icon: IconName }
> = {
  expert: {
    label: "Expert Answer",
    color: "green",
    icon: "shield",
  },
  web: {
    label: "Web Search",
    color: "blue",
    icon: "external-link",
  },
  attachment: {
    label: "Attached File",
    color: "primary",
    icon: "paperclip",
  },
  ai: {
    label: "AI",
    color: "secondary",
    icon: "sparkling",
  },
}

export type AnswerSourceBadgeProps = {
  citations?: SearchCitationData[] | null
  expertAnswer?: ExpertQuestion | null
  className?: string
}

export const AnswerSourceBadge: React.FC<AnswerSourceBadgeProps> = ({
  citations,
  expertAnswer,
  className,
}) => {
  const kind = getChatAnswerSourceKind(citations, expertAnswer)
  const { label, color, icon } = BADGE_CONFIG[kind]

  return (
    <Chip
      className={className ?? styles.sourceBadge}
      color={color}
      variant="rounded"
      before={<Icon name={icon} />}
    >
      {label}
    </Chip>
  )
}

export default AnswerSourceBadge
